import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { calculators } from '@/registry'
import { CalculatorCard } from '@/components/ui/CalculatorCard'

const POPULAR_SLUGS = ['ohms-law', 'battery-runtime', 'electricity-cost']

export function NotFoundPage() {
  const popular = POPULAR_SLUGS.map(slug => calculators.find(c => c.slug === slug)).filter(Boolean) as typeof calculators

  return (
    <>
      <Helmet>
        <title>404 — Calculator Not Found | Toolvance</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Calculator not found.</h2>
        <p className="text-gray-500 mb-8">The page you are looking for does not exist.</p>
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link to="/" className="px-6 py-3 bg-brand-600 text-white rounded-lg hover:bg-brand-700 font-semibold">Home</Link>
          <Link to="/" className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-semibold">All Calculators</Link>
        </div>
        <h2 className="text-lg font-bold text-gray-900 mb-4">Popular Calculators</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
          {popular.map(c => <CalculatorCard key={c.slug} calc={c} />)}
        </div>
      </div>
    </>
  )
}
